import { render, staticRenderFns } from "./dibu.vue?vue&type=template&id=723d120a&scoped=true&"
import script from "./dibu.vue?vue&type=script&lang=js&"
export * from "./dibu.vue?vue&type=script&lang=js&"
import style0 from "./dibu.vue?vue&type=style&index=0&id=723d120a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723d120a",
  null
  
)

export default component.exports